export default function cleanTicksOnXAxis(svg, maxValues) {
    // Remove ticks from the x-axis except for the first and last
    return svg
        .selectAll(".x-axis .tick")
        .filter((d, i) => i !== 0 && i !== maxValues - 1)
        .remove();
}
